var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18506 5.79387C9.61027 4.84158 11.2859 4.33333 13 4.33333C15.2985 4.33333 17.503 5.24642 19.1283 6.87173C20.7536 8.49705 21.6667 10.7014 21.6667 12.9999C21.6667 14.714 21.1584 16.3897 20.2061 17.8149C19.2538 19.2401 17.9002 20.351 16.3166 21.0069C14.733 21.6629 12.9904 21.8345 11.3092 21.5001C9.62807 21.1657 8.08381 20.3403 6.87175 19.1282C5.65969 17.9162 4.83427 16.3719 4.49986 14.6907C4.16546 13.0096 4.33709 11.267 4.99306 9.68335C5.64901 8.09973 6.75984 6.74618 8.18506 5.79387Z",
    stroke: "#AFAFAF",
    strokeWidth: 2.16667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 13H8.66658L10.2916 9.75L13.5416 16.25L15.7082 11.9167L16.2499 13H21.6666",
    stroke: "#AFAFAF",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.4a603de46dc8b047fd89c99d40b072dc.svg";
export { ForwardRef as ReactComponent };